import styled from 'styled-components';
import { palette } from 'styled-theme';
import Buttons from '@iso/components/uielements/button';
import Table from '../Tables/AntTables/AntTables.styles';
import {
  transition,
  borderRadius,
  boxShadow,
} from '@iso/lib/helpers/style_utils';
import NoBoardFounds from '../ScrumBoard/Board/BoardNotFound/BoardNotFound';
import { AppContext } from '../../context/ContextProvider';
import { useContext } from 'react';

const MyTable = ({...props}) => {
  const { componentLoader, fetching } = useContext(AppContext);
  return <Table 
    {...props} 
    loading={(Object.values(componentLoader).some((item) => item.value === true) || Object.values(fetching).some((item) => item === true)) ? false : props.loading}
    locale={{
      ...props.locale,
      emptyText: <NoBoardFounds section={"No Board"} style={{ height: "200px" }} />
    }}
  />
}

export const StyledModalWrapper = styled.div`
  .transfer-ownership-modal .ant-modal-content {
    border-radius: 12px;
    padding: 24px;
  }

  .transfer-ownership-modal .ant-modal-header {
    border-radius: 12px 12px 0 0;
    border-bottom: none;
  }

  .transfer-ownership-modal .ant-modal-title {
    font-size: 18px;
    font-weight: 600;
    color: #222;
  }

  .transfer-ownership-modal .ant-modal-body {
    padding-top: 16px;
  }

  .transfer-ownership-modal .ant-select {
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .transfer-ownership-modal .ant-btn-primary {
    background-color: rgb(19, 47, 68);
    border-color: rgb(19, 47, 68);
  }

  .transfer-ownership-modal .ant-btn-primary:hover,
  .transfer-ownership-modal .ant-btn-primary:focus {
    background-color: rgb(25, 60, 85); /* Slightly lighter for hover */
    border-color: rgb(25, 60, 85);
  }

  /* Invite User Modal Styles */
  .invite-user-modal .ant-modal-content {
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }

  .invite-user-modal .ant-modal-header {
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid #f0f0f0;
    padding: 16px 24px;
  }

  .invite-user-modal .ant-modal-title {
    font-size: 18px;
    font-weight: 600;
    color: #132f44;
    font-family: 'Poppins', sans-serif;
  }

  .invite-user-modal .ant-modal-body {
    padding: 24px;
    max-height: 80vh;
    overflow-y: auto;
  }

  .invite-user-modal .ant-modal-body::-webkit-scrollbar {
    width: 6px;
  }

  .invite-user-modal .ant-modal-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .invite-user-modal .ant-modal-body::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  .invite-user-modal .ant-modal-body::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .invite-user-modal .ant-modal-close {
    top: 16px;
    right: 16px;
  }

  .invite-user-modal .ant-modal-close-x {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }

  .invite-user-modal .ant-input,
  .invite-user-modal .ant-select-selector {
    border-radius: 6px;
    border-color: #d9d9d9;
  }

  .invite-user-modal .ant-input:focus,
  .invite-user-modal .ant-input:hover,
  .invite-user-modal .ant-select-selector:focus,
  .invite-user-modal .ant-select-focused .ant-select-selector {
    border-color: #132f44;
    box-shadow: 0 0 0 2px rgba(19, 47, 68, 0.1);
  }

  .invite-user-modal .ant-btn-primary {
    background-color: #132f44;
    border-color: #132f44;
  }

  .invite-user-modal .ant-btn-primary:hover,
  .invite-user-modal .ant-btn-primary:focus {
    background-color: #1a3d57;
    border-color: #1a3d57;
  }

  .invite-user-modal .ant-btn-primary:disabled {
    background-color: #d9d9d9;
    border-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
  }

  .invite-user-modal .ant-btn-default:hover {
    border-color: #132f44;
    color: #132f44;
  }
`;

const TableWrapper = styled(MyTable)`
  .ant-table-bordered .ant-table-thead > tr > th {
    background-color: #132f44 !important;
    color: white;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 500;
  }

  .ant-table-bordered .ant-table-thead > tr > th .ant-table-column-sorter {
    color: #ffffff !important;
  }

  .ant-table-bordered .ant-table-thead > tr > th .ant-table-column-sorter-up,
  .ant-table-bordered .ant-table-thead > tr > th .ant-table-column-sorter-down {
    color: #ffffff !important;
  }

  .ant-table-bordered .ant-table-thead > tr > th .anticon {
    color: #ffffff !important;
  }

  .ant-table-body {
    height: auto;
  }

.ant-table-container {
  min-height: fit-content !important;
  position: relative;
}

  .even-rows {
    background-color: #fbfbfb;
  }

  .ant-table-bordered .ant-table-tbody > tr > td {
    color: #292929;
    font-family: Nunito Sans;
    font-size: 12px;
    font-weight: 500;
  }
  .ant-table-bordered .ant-table-thead > tr > th,
  .ant-table-bordered .ant-table-tbody > tr > td {
    white-space: normal;
    &.noWrapCell {
      white-space: nowrap;
    }

    // @media only screen and (max-width: 920px) {
    //   white-space: nowrap;
    // }
  }

  .customHeaderCss {
    .ant-table-bordered .ant-table-thead > tr > th{
        background-color: green;
    }
  }

  .myTableWrapper {
    .ant-table-bordered .ant-table-thead > tr > th{
      background-color: transparent;
    }
  }  

  .isoImgWrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: ${palette('grayscale', 9)};
    ${borderRadius('50%')};

    img {
      height: 100%;
      object-fit: cover;
    }

    .userActivity {
      width: 10px;
      height: 10px;
      display: block;
      background-color: ${palette('color', 3)};
      position: absolute;
      bottom: 0;
      right: 3px;
      border: 1px solid #ffffff;
      ${borderRadius('50%')};
    }
  }

  &.ant-table-wrapper.isoBlueTable {
    .ant-table-bordered .ant-table-thead > tr > th {
      background-color: #132f44 !important;
      color: white;
      font-family: Poppins;
      font-size: 14px;
      font-weight: 500;
    }

    .ant-table-bordered .ant-table-thead > tr > th .ant-table-column-sorter {
      color: #ffffff !important;
    }

    .ant-table-bordered .ant-table-thead > tr > th .ant-table-column-sorter-up,
    .ant-table-bordered .ant-table-thead > tr > th .ant-table-column-sorter-down {
      color: #ffffff !important;
    }

    .ant-table-bordered .ant-table-thead > tr > th .anticon {
      color: #ffffff !important;
    }

    .ant-table-container table>thead>tr:first-child >*:last-child{
      border-bottom: 1px solid #f1f3f6 ;
    }

    .ant-table-bordered .ant-table-tbody > tr > td {
      color: #292929;
      font-family: Nunito Sans;
      font-size: 12px;
      font-weight: 500;
    }
    
    // .ant-table-bordered .ant-table-tbody > tr > td .ant-empty.ant-empty-normal {
    //   margin: 0;
    // }
    
    // .ant-table-bordered .ant-table-tbody > tr > td .ant-empty.ant-empty-normal .ant-empty-image {
    //   width: 20px;
    //   height: 20px;
    // }

    .ant-table-bordered .ant-table-thead > tr > th,
    .ant-table-bordered .ant-table-tbody > tr > td {
      white-space: normal;
      &.noWrapCell {
        white-space: nowrap;
      }

      // @media only screen and (max-width: 920px) {
      //   white-space: nowrap;
      // }
    }

    .even-rows {
      background-color: #fbfbfb;
    }

    .customHeaderCss {
      .ant-table-bordered .ant-table-thead > tr > th{
          background-color: green;
      }
    }

    .myTableWrapper {
      .ant-table-bordered .ant-table-thead > tr > th{
        background-color: transparent;
      }
    }  

    .isoImgWrapper {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      background-color: ${palette('grayscale', 9)};
      ${borderRadius('50%')};

      img {
        height: 100%;
        object-fit: cover;
      }

      .userActivity {
        width: 10px;
        height: 10px;
        display: block;
        background-color: ${palette('color', 3)};
        position: absolute;
        bottom: 0;
        right: 3px;
        border: 1px solid #ffffff;
        ${borderRadius('50%')};
      }
    }

    // &.isoBlueTableWrapper {
    //   .ant-table-container table > thead > tr:first-child > :first-child {
    //     background: #132f44 !important;
    // }
    //   .ant-table-container{
    //   margin-bottom:0px !important;
    //   }
    // }
  }

  &.ant-table-wrapper.isoBlueTable.nodegroups-subTable{
    .ant-table-bordered .ant-table-tbody > tr > td .ant-empty.ant-empty-normal {
      margin: 0;
    }

    .ant-table-bordered .ant-table-tbody > tr > td .ant-empty.ant-empty-normal .ant-empty-image {
      height: 30px;
    }
  }
`;

const StatusTag = styled.span`
  padding: 0 5px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  background-color: ${palette('primary', 0)};
  font-size: 12px;
  color: #ffffff;
  text-transform: capitalize;

  &.draft {
    background-color: ${palette('warning', 0)};
  }

  &.publish {
    background-color: ${palette('success', 0)};
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  align-items: center;
`;

const ButtonHolders = styled.div``;

const ComponentTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: ${palette('text', 0)};
  margin: 5px 0;
`;

const ActionBtn = styled(Buttons)`
  && {
    padding: 0 12px;
    margin-right: 15px;

    &:last-child {
      margin-right: 0;
    }

    i {
      font-size: 17px;
      color: ${palette('text', 1)};
    }

    &:hover {
      i {
        color: inherit;
      }
    }
  }
`;

const Fieldset = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Label = styled.label`
  font-size: 13px;
  color: ${palette('text', 1)};
  line-height: 1.5;
  font-weight: 500;
  padding: 0;
  margin: 0 0 8px;
`;

const ActionWrapper = styled.div`
  display: flex;
  align-content: center;

  a {
    margin-right: 12px;
    &:last-child {
      margin-right: 0;
    }

    i {
      font-size: 18px;
      color: ${palette('primary', 0)};

      &:hover {
        color: ${palette('primary', 4)};
      }
    }

    &.deleteBtn {
      i {
        color: ${palette('error', 0)};

        &:hover {
          color: ${palette('error', 2)};
        }
      }
    }
  }
`;

const Form = styled.div``;

export {
  ActionBtn,
  Fieldset,
  Label,
  Form,
  TitleWrapper,
  ButtonHolders,
  ActionWrapper,
  ComponentTitle,
  TableWrapper,
  StatusTag,
};
